//検索結果一覧画面取得項目
export const KIGYO_LIST_ITEMS: string[] = [
  "SHOGO_KANJI",
  "SHOGO_KANA",
  "JUSHO",
  "JUSHO_CODE",
  "DAIHYOSHA_KANJI",
  "DAIHYOSHA_KANA",
  "KIGYO_CODE",
  "YUBIN_NO",
  "SHIHONKIN",
  "JUGYOINSU",
  "URIAGE1",
  "RIEKI1",
  "MIKOMI_SUITEI_KUBUN1",
];

//企業情報詳細画面取得項目
export const KIGYO_DETAIL_ITEMS: string[] = [
  "KIGYO_CODE", "JOJO", "CHOSA_NENGAPPI", "SHOGO_KANA", "SHOGO_KANJI", "DAIHYOSHA_KANA", "DAIHYOSHA_KANJI", "YUBIN_NO",
  "JUSHO_CODE", "JUSHO", "DENWA_NO", "SHIHONKIN", "SETSURITSU_NENGETSU", "SOGYO_NENGETSU", "JUGYOINSU", "GYOSHU1", "GYOSHU2", "GYOSHU3",
  "EIGYO_SHUMOKU1", "EIGYO_SHUMOKU2", "EIGYO_SHUMOKU3", "EIGYO_SHUMOKU4", "EIGYO_SHUMOKU5",
  "EIGYO_SHUMOKU6", "EIGYO_SHUMOKU7", "EIGYO_SHUMOKU8", "EIGYO_SHUMOKU9", "EIGYO_SHUMOKU10",
  "EIGYOSHO_SHITEN1", "EIGYOSHO_SHITEN2", "EIGYOSHO_SHITEN3", "EIGYOSHO_SHITEN4", "EIGYOSHO_SHITEN5",
  "EIGYOSHO_SHITEN6", "EIGYOSHO_SHITEN7", "EIGYOSHO_SHITEN8", "EIGYOSHO_SHITEN9", "EIGYOSHO_SHITEN10",
  "YAKUIN1", "YAKUIN2", "YAKUIN3", "YAKUIN4", "YAKUIN5", "YAKUIN6", "YAKUIN7", "YAKUIN8", "YAKUIN9", "YAKUIN10",
  "SHIIRESAKI1", "SHIIRESAKI2", "SHIIRESAKI3", "SHIIRESAKI4", "SHIIRESAKI5",
  "SHIIRESAKI6", "SHIIRESAKI7", "SHIIRESAKI8", "SHIIRESAKI9", "SHIIRESAKI10",
  "KABUNUSHI1", "KABUNUSHI2", "KABUNUSHI3", "KABUNUSHI4", "KABUNUSHI5",
  "KABUNUSHI6", "KABUNUSHI7", "KABUNUSHI8", "KABUNUSHI9", "KABUNUSHI10",
  "HAMBAISAKI1", "HAMBAISAKI2", "HAMBAISAKI3", "HAMBAISAKI4", "HAMBAISAKI5",
  "HAMBAISAKI6", "HAMBAISAKI7", "HAMBAISAKI8", "HAMBAISAKI9", "HAMBAISAKI10",
  "MIKOMI_SUITEI_KUBUN1", "MIKOMI_SUITEI_KUBUN2", "MIKOMI_SUITEI_KUBUN3",
  "KESSAN_NENGETSU1", "KESSAN_NENGETSU2", "KESSAN_NENGETSU3", "URIAGE1", "URIAGE2", "URIAGE3",
  "RIEKI1", "RIEKI2", "RIEKI3", "HAITO_SOGAKU1", "HAITO_SOGAKU2", "HAITO_SOGAKU3",
  "TORIHIKI_GINKO1", "TORIHIKI_GINKO2", "TORIHIKI_GINKO3", "TORIHIKI_GINKO4", "TORIHIKI_GINKO5",
  "TORIHIKI_GINKO6", "TORIHIKI_GINKO7", "TORIHIKI_GINKO8", "TORIHIKI_GINKO9", "TORIHIKI_GINKO10",
  "GAIKYO", "URIAGE_SHINCHORITSU", "RIEKI_SHINCHORITSU", "DAIHYOSHA", "GENJUSHO_YUBIN_NO", "GENJUSHO_JUSHO",
  "SEINENGAPPI", "ETO", "SHUSSHINCHI", "SHUSSHINKO",
];
